import React, { PureComponent } from "react";
import Skeleton from '@mui/material/Skeleton';

export default class SkeletonReport extends PureComponent {
  render() {
    return (
      <div>
        <h1 className="loadingRemainingReport">
          Loading  Reports
          <span class="dot-one"> .</span>
          <span class="dot-two"> .</span>
          <span class="dot-three"> .</span>
        </h1>
        {/* <Skeleton variant={"circle"} width={"100%"} height={40} />
        <div
          style={{
            flex: "1 1 50%",
          }}
        >
          <Skeleton
            variant={"text"}
            width={"90%"}
            height={40}
            // animation="wave"
            sx={{ bgcolor: '#ffffff' }}
          />
          <Skeleton
            variant={"text"}
            width={"70%"}
            height={40}
            // animation="wave"
            sx={{ bgcolor: '#ffffff' }}
          />
          <Skeleton
            variant={"text"}
            width={"60%"}
            height={40}
            // animation="wave"
            sx={{ bgcolor: '#ffffff' }}
          />
          <Skeleton
            variant={"text"}
            width={"50%"}
            height={40}
            // animation={false}
            sx={{ bgcolor: '#ffffff' }}
          />
          <Skeleton
            variant={"text"}
            width={"90%"}
            height={40}
            // animation="wave"
            sx={{ bgcolor: '#ffffff' }}
          />
          <Skeleton
            variant={"text"}
            width={"50%"}
            height={40}
            // animation="wave"
            sx={{ bgcolor: '#ffffff' }}
          />
          
        </div> */}
      </div>
    );
  }
}
